import { Box, Typography } from '@mui/material'

interface JourneyDetailsProps {
  status?: string
}

const containerStyles = {
  p: 2,
  borderTop: '2px solid #F6F4F4',
  borderBottom: '2px solid #F6F4F4',
}

const clickableRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}

const labelStyles = {
  fontSize: '13.33px',
  color: '#767676',
  fontWeight: 500,
  display: 'block',
  mb: 0.5,
  lineHeight: '150%',
  letterSpacing: '0.15px',
}

const statusTextStyles = {
  fontSize: '16px',
  fontWeight: 600,
  color: '#1D1A33',
  lineHeight: '150%',
  letterSpacing: '0.15px',
}

export const DeliveryJourneyDetails = ({ status }: JourneyDetailsProps) => {
  return (
    <Box sx={containerStyles}>
      <Box sx={clickableRowStyles}>
        <Box>
          <Typography variant='caption' sx={labelStyles}>
            Journey details
          </Typography>
          <Typography variant='h6' sx={statusTextStyles}>
            {status}
          </Typography>
        </Box>
        </Box>
    </Box>
  )
}
